import React from "react";
import Title from "../layout/Title";
import Section from "../layout/Section";
import DienstCard from "../diensten/DienstCard";
import {faEye, faRecordVinyl, faShieldHalved} from "@fortawesome/free-solid-svg-icons";

const MissieVisie: React.FC = () => {
    return (
        <>
            <Section>
                <Title title='Onze Missie, Visie en Kernwaarden'/>
                <div className="container">
                    <div className="row">
                        <DienstCard
                            cols='col-lg-4 col-md-12 col-sm-12'
                            cardId="Missie"
                            faIcon={faShieldHalved}
                            bgColor="bg-1"
                            bgIcon="bg-training"
                            title="Missie"
                            subtitle="Onze missie is om een onderneming uit te bouwen waarin iedereen de beste versie van zichtzelf kan zijn en waarin we voor technologische innovaties zorgen die de wereld verbeteren."
                        />
                        <DienstCard
                            cols='col-lg-4 col-md-12 col-sm-12'
                            cardId="Visie"
                            faIcon={faEye}
                            bgColor="bg-1"
                            bgIcon="bg-training"
                            title="Visie"
                            subtitle="Onze slogan ‘Connection creates Excellence’ geeft het volledig aan. Door connecties binnen het team en met de maatschappij, streven we ernaar onze missie, technologische innovatie verwezenlijken, te stimuleren."
                        />
                        <DienstCard
                            cols='col-lg-4 col-md-12 col-sm-12'
                            cardId="Kernwaarden"
                            faIcon={faRecordVinyl}
                            bgColor="bg-1"
                            bgIcon="bg-training"
                            title="Kernwaarden"
                            subtitle="Wij geloven erin dat we met een ondernemende mindset met onze teamleden centraal, gecombineerd met transparantie en heel veel fun, de beste resultaten kunnen verwezenlijken."
                        />
                    </div>
                </div>
            </Section>
        </>
    );
};

export default MissieVisie;